// Pure decision functions extracted from ChartCanvas.jsx (Fase 1 P1, bloco
// render-core). They were inline expressions in class methods (getMoreProps /
// UNSAFE_componentWillReceiveProps) reachable only by mounting the component;
// vitest runs in the node environment without jsdom, so the decision arithmetic
// lives here and the class delegates. Behaviour is identical — only the
// boolean/selection moved out.
//
// Serves Directive 2 (interativos leem chartConfig fresco no draw-time) and
// Directive 8 (pan/zoom locks never produce a stale-overwrite).

// --- D2 ----------------------------------------------------------------
// Interactive overlays read chartConfig at DRAW time via getLatestChartConfig.
// During a zoom gesture the freshest config is stashed on `latestChartConfig`
// BEFORE React's setState commits it to `state.chartConfig`; the getter must
// prefer the stashed value so interactives draw against the current yScale,
// never the previous one (the #351 stale-Y class). Falls back to committed
// state when no fresher value exists.
export function latestChartConfigOf(latestChartConfig, stateChartConfig) {
  return latestChartConfig || stateChartConfig;
}

// --- D8 ----------------------------------------------------------------
// UNSAFE_componentWillReceiveProps recomputes newState on every prop change but
// must NOT push it via setState while a pan or zoom gesture is in flight, nor
// within 150ms of a zoom: doing so would overwrite the gesture's not-yet-
// committed setState (race → "dancing"/bounce). It still keeps `fullData`
// up to date (caller assigns it) and bails early. This predicate is the single
// source of truth for that early-return.
export const POST_ZOOM_QUIET_MS = 150;

export function shouldSkipStateUpdateDuringGesture(
  panInProgress,
  zoomInProgress,
  timeSinceZoom,
) {
  return !!(
    panInProgress ||
    zoomInProgress ||
    timeSinceZoom < POST_ZOOM_QUIET_MS
  );
}
